<template>
  <router-view/>
</template>

<style>
/* .container {
  max-width: 1000px;
} */
.print-big{
      font-size: larger !important;
    }
@media print {
    @page {
        /* size: letter; */
        /* size: A3; */
        /* margin-top: 1mm;
        margin-bottom: 12mm; */
        /* margin: 0mm 10mm 10mm 10mm; */
    }

a[href]:after { content: none !important; }

    html {
        background-color: #FFFFFF;
        margin: 0px;
        /* page-break-before: avoid !important; */
        height: auto;
    }

    
      body{
        /* zoom: 90% !important; */
        
        /* max-width: none !important;
        font-size: small;
        height: auto; */
        /* width: 90%; */
    } 

    .container {
        display: inline;
    }

    .CalendarPrintTable {
        visibility: visible;
        display: table;
        margin: 0px auto;
    }

    .remove-space-above{
      margin-top: -25px;
    }

    .noprint {
        display: none !important;
    }

    .print-margin-top {
        margin-top: 10px !important;
    }

    .print-margin-more-top {
        margin-top: 40px !important;
    }

    .print-big{
      font-size: larger !important;
    }
}

.pf-table {
  width: 100%;
}
.pf-ghost-div {
  border-radius: 8px !important;
  border: 4px solid #e2eaee !important;
  background-color: ghostwhite !important;
}
.pf-no-border {
  border: none !important;
}
.icoLink {
  color: #006185 !important;
}
.pf-table-row {
  display: table-row;
}

.pf-label-table-cell {
  display: table-cell;
  font-weight: bold;
  padding: 10px 10px 10px 10px;
}

a.link:hover {
  color: #00cd00 !important;
  text-decoration: none;
}

.navbar {
  pointer-events: auto;
  cursor: pointer;
}
</style>